import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import { RootState } from "../../redux/store"; // Import RootState type
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import moment from "moment";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function ProjectView() {
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [UsersData, setUsersData] = useState<any[]>([]); // Ensure default value is an array
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    getprojectData();
  }, []); // Empty array to ensure the effect runs only on component mount

  const getprojectData = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query") || "", // Fallback in case query is undefined
        assignedTo: user.id || null, // Default to null if not provided
      };
      const url = API.PROJECT_LIST_EMPLOYEE;
      const response: any = await POST(url, obj);
      setUsersData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch user data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      key: "projectName",
      dataIndex: "projectName",
      title: "Project Name",
      render: (projectName: string) => <span>{projectName}</span>,
    },
    {
      key: "projectType",
      dataIndex: "projectType",
      title: "Project Type",
      render: (projectType: string) => <span>{projectType}</span>,
    },
    {
      key: "startDate",
      dataIndex: "startDate",
      title: "Start Date",
      render: (startDate: string) => (
        <span>{moment(startDate).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      key: "endDate",
      dataIndex: "endDate",
      title: "End Date",
      render: (endDate: string) => {
        const isOverdue = moment(endDate).isBefore(moment(), "day"); // Check if the date has passed
        return (
          <span style={{ color: isOverdue ? "red" : "inherit" }}>
            {moment(endDate).format("YYYY-MM-DD")}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: any) => {
        let color = "";

        // Assign colors based on the status value
        switch (status?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;
          case "running":
            color = "blue";
            break;
          case "in-progress":
            color = "purple";
            break;
          default:
            color = "black"; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Employee/project_view/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);

  const filterProject = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),

        projectName: values.projectName,
        clientid: values.clientid,
        assignedTo: values.assignedTo,
        status: true,
      };
      const url = API.PROJECT_FILTERING;
      const response: any = await POST(url, obj);
      setUsersData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!user) {
    return <Spin tip="Loading employee details..." />;
  }

  return (
    <>
      <Card>
        <Card>
          <Form form={form} onFinish={filterProject} layout="vertical">
            <Row gutter={16} align="middle">
              <Col sm={6}>
                <Form.Item name="projectName" label=" projectName">
                  <Input placeholder=" projectName" allowClear />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        <Card>
          <h2 style={{ textAlign: "center" }}> PROJECT DETAILS</h2>
          <Table
            columns={columns}
            dataSource={UsersData}
            pagination={{ pageSize: 5 }}
            loading={isLoading}
          />
        </Card>
      </Card>
    </>
  );
}

export default ProjectView;
